import { render, staticRenderFns } from "./VisaoGeralAutoriz.vue?vue&type=template&id=f6f96252&"
import script from "./VisaoGeralAutoriz.vue?vue&type=script&lang=js&"
export * from "./VisaoGeralAutoriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports